import PrivacyPolicy from './Docs/PrivacyPolicy';
import TermsOfUse from './Docs/TermsOfUse';
import TermsAndConditions from './Docs/TermsAndConditions';
import LegalDocs from './LegalDocsView';

export const LegalDocsRouter = [{
  path: '/legal',
  name: 'LegalDocsView',
  component: LegalDocs,
  children: [
    {
      path: '/legal/privacy-policy',
      name: 'Legal',
      component: PrivacyPolicy,
    },
    {
      path: '/legal/terms-of-use',
      name: 'TermsOfUse',
      component: TermsOfUse,
    },
    {
      path: '/legal/terms-and-conditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions,
    },
  ],
}];

export default LegalDocsRouter;
